import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import {ToastContainer} from "react-toastify";

const LayoutRoute = ({component: Component, layout: Layout, ...rest}) => {
    const user = localStorage.getItem('Gein[user]');
    let isAuthenticated = Boolean(user);

    return <Route
        {...rest}
        render={props => (
            <Layout>
                <ToastContainer/>
                {!isAuthenticated && rest.location.pathname !== '/login' && <Redirect to="/login"/>}
                <Component {...props}/>
            </Layout>
        )}
    />
};

export default LayoutRoute;



// WEBPACK FOOTER //
// ./src/components/Layout/LayoutRoute.js